"use client";
/*
 * Documentation:
 * Category Label — https://app.subframe.com/99e12bf47278/library?component=Category+Label_770d931d-240d-4a60-a0be-bbe2d360c3d3
 * Icon Button — https://app.subframe.com/99e12bf47278/library?component=Icon+Button_af9405b1-8c54-4e01-9786-5aad308224f6
 */

import React from "react";
import * as SubframeCore from "@subframe/core";
import { IconButton } from "./IconButton";

interface CategoryLabelRootProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: React.ReactNode;
  icon?: SubframeCore.IconName;
  className?: string;
}

const CategoryLabelRoot = React.forwardRef<HTMLElement, CategoryLabelRootProps>(
  function CategoryLabelRoot(
    { text, icon = null, className, ...otherProps }: CategoryLabelRootProps,
    ref
  ) {
    return (
      <div
        className={SubframeCore.twClassNames(
          "flex w-full flex-col items-center justify-center gap-2",
          className
        )}
        ref={ref as any}
        {...otherProps}
      >
        <div className="flex grow shrink-0 basis-0 items-center gap-0.5 rounded-md border border-solid border-brand-100 bg-brand-100 px-1 py-px">
          {text ? (
            <span className="whitespace-nowrap text-caption font-caption text-brand-800">
              {text}
            </span>
          ) : null}
          <IconButton
            className="h-4 w-4 flex-none"
            size="small"
            icon="FeatherX"
          />
          <SubframeCore.Icon
            className="text-caption font-caption text-brand-700"
            name={icon}
          />
        </div>
      </div>
    );
  }
);

export const CategoryLabel = CategoryLabelRoot;
